import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '@gokrew/models/constants';
import type { LeaveDayCountParams } from '@gokrew/models/leaves';
import { getEmployeeLeaveDayCount } from '@/api/leave-management';

/**
 * The days a leave typed for an employee would deduct, counted by the server
 * exactly as the saved request will be (their branch, observed holidays).
 * Idle until an employee is picked and the dates are complete.
 */
export function useLeaveDayCount(
  companyId: string | null | undefined,
  employeeId: string | null | undefined,
  params?: LeaveDayCountParams
) {
  return useQuery({
    queryKey: [QueryKeys.LeaveDayCount, companyId, employeeId, params],
    queryFn: () => getEmployeeLeaveDayCount(companyId!, employeeId!, params!),
    enabled: !!companyId && !!employeeId && !!params,
    select: (res) => res.data,
    staleTime: 60_000,
    retry: false,
  });
}
